import React from 'react'
import Modal from '@material-ui/core/Modal'
import styled from 'styled-components'
import * as Colors from '../../constants/colors'
import { ILiveWorkout } from '../../types'

import { SUBSCRIPTION_OUTLINE, SUBSCRIPTION_FILL } from '../../constants/colors'
import SubscriptionComponent from '../../pages/index'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { PHONE } from '../../constants/measurements'
import { isMobile } from 'react-device-detect'

const top = 40
const left = 40

export const Body = styled.div`
  position: absolute;
  width: 1130px;
  height: 80vh;
  top: ${`${top}%`};
  left: ${`${left}%`};
  transform: ${`translate(-${top}%, -${left}%)`};
  background: white;
  outline: none;
  border-radius: 4px;
  background: ${Colors.themeColors.pageBg};
  color: ${Colors.themeColors.textColor};
  display: flex;
  justify-content: center;
  overflow: scroll;
  border: 1px solid rgba(255, 255, 255, 0.3);
  flex-direction: column;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  @media (max-width: ${PHONE}) {
    width: 100%;
    height: 100vh;
  }
`

export const Title = styled.div`
  font-size: 22px;
  margin-bottom: 5px;
`

export const Date = styled.div`
  margin-bottom: 40px;
`

export const Wrap = styled.div`
  width: 350px;
  margin-right: 80px;
`

export const Subscriptions = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 50px;
`

export const SubscriptionContainer = styled.div<{
  isSelected: boolean
}>`
  margin-right: 22px;
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border: 2px solid
    ${({ isSelected }) =>
      isSelected ? SUBSCRIPTION_FILL : SUBSCRIPTION_OUTLINE};
  border-radius: 15px;
  width: 100%;
  padding: 20px 16px;
  background-color: ${({ isSelected }) =>
    isSelected ? SUBSCRIPTION_FILL : 'transparent'};
`

interface Props {
  open: boolean
  handleClose: () => void
  workout: ILiveWorkout
}

const PurchaseModal = ({ open, handleClose }: Props) => (
  <Modal
    open={open}
    onClose={handleClose}
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
  >
    <Body>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: isMobile ? 80 : 0,
          marginBottom: -40,
          zIndex: 9999,
        }}
      >
        <IconButton onClick={handleClose}>
          <CloseIcon style={{ color: Colors.themeColors.textColor }} />
        </IconButton>
      </div>
      <SubscriptionComponent
        // @ts-ignore
        hideNewsletter={true}
        defaultOpenPaymentForm={true}
        renderWithoutLayout={true}
      />
    </Body>
  </Modal>
)

export default PurchaseModal
